"use client";

import * as React from 'react';

// TODO

const FormContext = /*#__PURE__*/React.createContext({});
export default FormContext;